import useEventListener from 'react-use-event-listener'

export const useSearchShortcut = (toggleSearch: () => void): void => {
  const handler = (event: KeyboardEvent) => {
    if (event.key !== 'k' || (!event.metaKey && !event.ctrlKey)) {
      return
    }

    event.preventDefault()
    toggleSearch()
  }

  useEventListener('keydown', handler, document)
}
